// removed by extract-text-webpack-plugin
module.exports = {"nf-tooling-locations":"nf-tooling-locations","nf-support-email":"nf-support-email","nf-tooling-locations-message":"nf-tooling-locations-message"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/ToolingLocations/ToolingLocations.scss
// module id = 4993
// module chunks = 1